import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations, getDefaultLanguage } from '../lib/translations';

const LanguageContext = createContext(null);

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState(() => {
    // Check localStorage first
    const saved = localStorage.getItem('subguard_language');
    if (saved && (saved === 'en' || saved === 'fr')) return saved;
    
    // Check browser language
    const browserLang = navigator.language?.split('-')[0];
    if (browserLang === 'fr') return 'fr';
    return 'en';
  });

  const t = translations[language] || translations.en;

  const setLanguage = (lang) => {
    if (lang === 'en' || lang === 'fr') {
      setLanguageState(lang);
      localStorage.setItem('subguard_language', lang);
    }
  };

  // Helper function to get nested translation
  const translate = (key) => {
    const keys = key.split('.');
    let value = t;
    for (const k of keys) {
      value = value?.[k];
      if (value === undefined) return key;
    }
    return value;
  };

  return (
    <LanguageContext.Provider
      value={{
        language,
        setLanguage,
        t,
        translate,
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};
